
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useUser } from '@/contexts/UserContext';

const PERSONAL_SHOPPING_LISTS_COUNT = 'personal-shopping-lists-count';

/**
 * Hook to get count of shopping lists created by the current user only
 */
export const usePersonalShoppingLists = () => {
  const { user } = useUser();

  return useQuery({
    queryKey: [PERSONAL_SHOPPING_LISTS_COUNT, user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;
      
      // Count shopping lists created by the current user only
      const { count } = await supabase
        .from('shopping_lists')
        .select('*', { count: 'exact', head: true })
        .eq('user_id', user.id);
      
      return count || 0;
    },
    enabled: !!user,
  });
};
